import { render, staticRenderFns } from "./registerEntryModel8.vue?vue&type=template&id=58ac292d&scoped=true"
import script from "./registerEntryModel8.vue?vue&type=script&lang=js"
export * from "./registerEntryModel8.vue?vue&type=script&lang=js"
import style0 from "./registerEntryModel8.vue?vue&type=style&index=0&id=58ac292d&prod&scoped=true&lang=css"
import style1 from "./registerEntryModel8.vue?vue&type=style&index=1&id=58ac292d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ac292d",
  null
  
)

export default component.exports